/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Release_HelpInputs */



/**
* | output |
* | --- |
* | "How quickly audio returns to normal (ms) after VO ends" |
*
* @param {Audio_Description_Export_Automix_Release_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_release_help = /** @type {((inputs?: Audio_Description_Export_Automix_Release_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Release_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse de retour au niveau normal (ms) après la fin de la VO")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie schnell der Ton nach dem Ende des Voiceovers wieder in den Normalzustand zurückkehrt (ms).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quanto velocemente l'audio torna alla normalità (ms) dopo la fine della voce")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скорость возвращения звука к нормальному состоянию (мс) после окончания озвучки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Qué tan rápido el audio vuelve a la normalidad (ms) después de que finaliza la voz en off")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("VO结束后音频恢复正常所需的时间（毫秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("VO終了後、音声が正常に戻るまでの時間（ミリ秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉयस ओवर समाप्त होने के बाद ऑडियो कितनी जल्दी सामान्य स्थिति में लौटता है (मिलीसेकंड में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Com que rapidez o áudio retorna ao normal (em milissegundos) após o término da narração.")
	return /** @type {LocalizedString} */ ("How quickly audio returns to normal (ms) after VO ends")
});